import { observer } from 'mobx-react-lite';
import { roundInfoStore } from '@pascal/pascal-core/shared/core/store';
import { roundTimeStore } from '../../store/roundTimeStore';

export const RoundTime = observer(() => {
  const { time } = roundTimeStore;
  const { duration } = roundInfoStore;
  return (
    (time || time === 0) && (
      <div className={`c-m-time-svg ${time < duration / 2 ? 'orange' : 'green'}`}>
        <svg
          className='circle-chart'
          height='100%'
          viewBox='0 0 33.83098862 33.83098862'
          width='100%'
          xmlns='http://www.w3.org/2000/svg'
        >
          <defs>
            <linearGradient id='gradient'>
              <stop
                offset='0%'
                className='start-g-color'
                style={{ stopColor: 'rgba(31, 60, 114, 0.4)' }}
              />
              <stop offset='100%' style={{ stopColor: 'rgba(31, 60, 114)' }} />
            </linearGradient>
          </defs>
          <circle
            className='circle-chart__background'
            cx='16.91549431'
            cy='16.91549431'
            r='14'
            stroke='none'
            strokeOpacity='0.16'
            strokeWidth='2.5'
          />
          <circle
            className='round-loader circle-chart__circle'
            cx='16.91549431'
            cy='16.91549431'
            fill='none'
            r='14'
            strokeLinecap='round'
            strokeWidth='2.5'
            strokeDasharray='100'
            strokeDashoffset={-(100 - (100 * time) / duration)}
          />
        </svg>
        <span className='c-m-time-svg-txt'>{time}</span>
      </div>
    )
  );
});
